module.exports = __webpack_public_path__ + "img/icon-bg(4).432e752c.svg";